import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TextControl from '../../components/TextControl';
import NumberControl from '../../components/NumberControl';
import moment from 'moment';
import { getStatusClass } from '../../Utils.js';
import { ReactComponent as PDF } from '../../icons/pdf.svg';
import { ReactComponent as Book } from '../../icons/book.svg';

export default function AdminProjects({ sessionValid, roles }) {
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(0);
  const [per, setPer] = useState(20);

  const getProjects = async () => {
    const data = await window.CPA.makeRequest('list-all-projects', 'GET');
    if (data) {
      setProjects(Object.values(data));
    }
  }

  document.title = 'All Projects | Chatwin Printing';

  useEffect(() => {
    getProjects();
  }, []);

  if (!sessionValid && !roles.admin) {
    return (<div className='card-container'>You need to <Link to='/login'>login</Link> to view this page.</div>)
  } else if (!roles.admin) {
    return (<div className='card-container'>You do not have permission to view this page.</div>)
  }

  return (
    <div className='card-container'>
      <div className='page-header'>
        <h1>All Projects</h1>
      </div>
      <div className='table-container'>
        <div className='table-header'>
          <div className='flex-1'>Status</div>
          <div className='flex-2'>Title</div>
          <div className='flex-1'>Customer</div>
          <div className='flex-1'>Quantity</div>
          <div className='flex-1'>Proof Type</div>
          <div className='flex-1'>Date Created</div>
        </div>
        <div className='table-body'>
          {projects.map((project) =>
            <div className='table-row' key={project._id}>
              <div className='flex-1'>
                <span className={`status-pill ${getStatusClass(project.status)}`}>{project.status}</span>
                {project.needsReview && <span className={`status-pill review`}>Needs Review</span>}
              </div>
              <div className='flex-2'><Link to={`/admin/project/${project._id}`}>{project.editionData.title}</Link></div>
              <div className='flex-1'>{project.customerData.organization}</div>
              <div className='flex-1'>{project.quantity}</div>
              <div className='flex-1'>{project.digitalProof ? 'Digital' : 'Print'}</div>
              <div className='flex-1'>{moment(project.created).format('LLL')}</div>
            </div>
          )}
          {projects.length == 0 && <div className='mt-large'><em>There are no projects yet.</em></div>}
        </div>
      </div>
    </div>
  )
}
